import {
  tab_panel_styles_default
} from "./chunk.S4W2PLMH.js";
import {
  component_mobile_styles_default
} from "./chunk.3DO35SD7.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/tab-panel/tab-panel.styles.ts
var tab_panel_styles_default2 = r` ${tab_panel_styles_default} ${component_mobile_styles_default} .tab-panel { padding: 0; padding-top: var(--sl-spacing-small); } `;

export {
  tab_panel_styles_default2 as tab_panel_styles_default
};
